import {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react'
import { debounce } from 'utils'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FilterContext } from 'features/dashboard/filter/FilterContext'

const FilterWrapper = forwardRef(({ children }, ref) => {
  const { isExpanded: lnbExpanded } = useSelector(state => state.lnb)
  const { filters } = useSelector(state => state.dashboard.filter)
  const { addVisible, setOverflow } = useContext(FilterContext)
  const [filterWidth, setFilterWidth] = useState(Number.MAX_SAFE_INTEGER)
  const updateFilterWidth = useCallback(() => {
    if (ref.current) {
      const width = ref.current.clientWidth
      if (filterWidth !== width) {
        setFilterWidth(width)
      }
    }
  }, [filterWidth, ref])
  useEffect(() => {
    updateFilterWidth()
    const debouncedUpdateFilterWidth = debounce(updateFilterWidth, 200)
    window.addEventListener('resize', debouncedUpdateFilterWidth)
    return () => {
      window.removeEventListener('resize', debouncedUpdateFilterWidth)
    }
  }, [updateFilterWidth])
  useEffect(() => {
    updateFilterWidth()
  }, [updateFilterWidth, lnbExpanded])
  useLayoutEffect(() => {
    if (ref.current) {
      const maxWidth = ref.current.clientWidth - 26
      let totalWidth = 0
      let hideNext = false
      Array.from(ref.current.childNodes)
        .filter(node => node.firstElementChild.className === 'box_adsearch')
        .forEach(node => {
          node.style.display = 'block'
          const width = node.clientWidth
          if (totalWidth + width > maxWidth) {
            hideNext = true
          }
          if (!addVisible && hideNext) {
            node.style.display = 'none'
          }
          totalWidth += width
        })
      if (totalWidth > maxWidth) {
        setOverflow(true)
      } else {
        setOverflow(false)
      }
    }
  }, [ref, filterWidth, filters, addVisible, setOverflow])
  return (
    <ul className="list_adsearch" ref={ref}>
      {children}
    </ul>
  )
})
FilterWrapper.propTypes = {
  children: PropTypes.node,
}
FilterWrapper.displayName = 'FilterWrapper'
export default FilterWrapper
